import { render, staticRenderFns } from "./ListDivision.vue?vue&type=template&id=325a53ff"
import script from "./ListDivision.vue?vue&type=script&lang=js"
export * from "./ListDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListDivision.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325a53ff')) {
      api.createRecord('325a53ff', component.options)
    } else {
      api.reload('325a53ff', component.options)
    }
    module.hot.accept("./ListDivision.vue?vue&type=template&id=325a53ff", function () {
      api.rerender('325a53ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListDivision.vue"
export default component.exports